// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content_Nbbyw","container":"container_knfpZ","information":"information_KjHmC","tick":"tick__nKbR","message":"message_lIZJy"};